import { render, staticRenderFns } from "./ExpensesType.vue?vue&type=template&id=23330200&scoped=true"
import script from "./ExpensesType.vue?vue&type=script&lang=js"
export * from "./ExpensesType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23330200",
  null
  
)

export default component.exports